import React from "react";
import { graphql } from "gatsby";
import { ContentTemplate, FilterBar, RelatedContent } from "@resourcehub/resourcehub-components";
import configGenerator from "@resourcehub/resourcehub-configuration";
import PageWrapper from "../../PageWrapper";

const ContentPageTemplate = ({ data, location, pageContext }) => {
    const { copy, item, items, site } = data;
    const filteredItems = items.edges.filter((edge) => edge.node.data.streams.includes(pageContext.streamId));
    const config = configGenerator({
        market: "cn",
        site: "consumer",
        locale: site.siteMetadata.lang,
        page: "cn-consumer-dynamic-content"
    });

    // TODO: Move this to config
    config.page.helmet.meta_title = item.data.seo_title || "";
    config.page.helmet.meta_description = item.data.seo_description || "";
    config.page.helmet.canonical_url = item.data.canonical_url || "";

    return (
        <PageWrapper config={config}>
            <main className="content">
                <div className="resources">
                    <FilterBar copyData={copy.data} vertical={site.siteMetadata.vertical} />
                    <ContentTemplate
                        copyData={copy.data}
                        domain={site.siteMetadata.domain}
                        item={item}
                        location={location}
                        vertical={site.siteMetadata.vertical}
                    />
                </div>
                <RelatedContent
                    copyData={copy.data}
                    items={filteredItems}
                    siteMetadata={site.siteMetadata}
                    title={copy.data.similar_resources}
                />
            </main>
        </PageWrapper>
    );
};

export default ContentPageTemplate;

export const pageQuery = graphql`
    query contentQuery($rawId: String!, $streamId: String!) {
        copy: airtable(data: { title: { eq: "cn-copy" } }) {
            ...PagesCopyFragment
        }
        item: airtable(id: { eq: $rawId }) {
            ...ItemFragment
        }
        items: allAirtable(
            filter: {
                table: { eq: "Items" }
                id: { ne: $rawId }
                data: { streams: { eq: $streamId }, market: { eq: "CN" } }
            }
        ) {
            edges {
                node {
                    ...ItemsFragment
                }
            }
        }
        site {
            ...SiteFragment
        }
        stream: airtable(id: { eq: $streamId }) {
            ...StreamFragment
        }
    }
`;
